/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerationRejectedTombstoneContainer_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"CaretContainer_viewer">;
    readonly " $refType": "ModerationRejectedTombstoneContainer_viewer";
};
export type ModerationRejectedTombstoneContainer_viewer$data = ModerationRejectedTombstoneContainer_viewer;
export type ModerationRejectedTombstoneContainer_viewer$key = {
    readonly " $data"?: ModerationRejectedTombstoneContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationRejectedTombstoneContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationRejectedTombstoneContainer_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CaretContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '4fef14bfabc70124c858eb86bfb4f8d6';
export default node;
